import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loading-3d',
    templateUrl: 'loading-3d.html',
    styleUrls: ['./loading-3d.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class Loading3DComponent {
    @Input() loadingText: string = '';
    @Input() loading: boolean = true;
}
